export default "__VITE_ASSET__BEv$D0X$__"